<!--  -->
<template>
  <div id="corporate">
    <NavBar title="关于王力" />
    <van-tabs
      v-model="activeName"
      color="#b19c4a"
    >
      <van-tab
        title="公司简介"
        name="a"
      >
        <div class="container pc-contain">
          <div class="compfile-cont">
            <div class="comp-title">
              <span class="line"></span>
              <h2 class="tit">全国安防门锁首家上市企业</h2>
              <div class="sub-txt">
                <p><br></p>
              </div>
              <div class="desc">
                <p v-html="introData.content"></p>
              </div>
            </div>
            <div class="data-block">
              <div class="data-item item1">
                <div class="comp-infor">
                  <h4>{{ introData.companyYear }}</h4>
                  <div class="desc">
                    <p>开创王力</p>
                  </div>
                </div>
              </div>
              <div class="data-item item2">
                <div class="comp-infor">
                  <h4>{{ introData.companyWorth }}亿</h4>
                  <div class="desc">
                    <p>品牌价值</p>
                    <p><br></p>
                  </div>
                </div>
              </div>
              <div class="data-item item3">
                <div class="comp-infor">
                  <h4>{{ introData.companySustain }}</h4>
                  <div class="desc">
                    <p>连续{{introData.companySustain}}年中国房地产500强首选供应商</p>
                    <!-- <p></p> -->
                  </div>
                </div>
              </div>
              <div class="data-item item4">
                <div class="comp-infor">
                  <h4>{{ introData.companyEmploy }}</h4>
                  <div class="desc">
                    <p>全球累计使用家庭</p>
                    <p>超5000万</p>
                  </div>
                </div>
              </div>
              <div class="data-item item5">
                <div class="comp-infor">
                  <h4>{{ introData.companyUser }}</h4>
                  <div class="desc">
                    累计2亿用户
                  </div>
                </div>
              </div>
              <div class="data-item item6">
                <div class="comp-infor">
                  <h4>{{ introData.companyBranch }}</h4>
                  <div class="desc">
                    <p>销售网点和服务网点</p>
                    <p>1万家</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab
        title="集团产业"
        name="b"
      >
        <ul class="cy-content show">
          <!--  -->
          <li
            class="wlaqm col-xs-6 col-sm-3"
            :data-num="index"
            v-for="(item,index) in industryrData"
            :key="index"
            @click="toDetail(index)"
          >
            <div class="cy-pic">
              <img :src="item.industryImages.length>0?item.industryImages[0].fullUrl:''">
            </div>
            <div class="cy-con">
              <div class="cyicon"></div>
              <div class="tit-cn">{{ item.name }}</div>
              <div class="tit-en">{{ item.alias }}</div>
            </div>
          </li>

        </ul>
      </van-tab>
      <van-tab
        title="集团荣誉"
        name="c"
      >
        <div class="cert-block">
          <div class="desc">
            <p
              v-for="(item,index) in honorData"
              :key="index"
            >{{ item.content }}</p>

          </div>
          <div class="pic">
            <img
              class=""
              src="//cdn.jihui88.com/upload//w//w1//wanglianfangs//picture//2021//07//16/0a5f68e0-a34f-4e9e-9967-71ebe02edafd.png"
            >
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import NavBar from '../../compents/header.vue'
export default {
  components: {
    NavBar
  },
  data () {
    return {
      activeName: 'a',
      honorData: [],
      industryrData: [],
      introData: []
    };
  },
  mounted () {
    this.$post('/api/wl-party-web-manager/homePage/honor').then(res => {
      this.honorData = [...res.data]
    })
    this.$post('/api/wl-party-web-manager/homePage/industry').then(res => {
      this.industryrData = [...res.data]
    })
    this.$post('/api/wl-party-web-manager/homePage/intro').then(res => {
      this.introData = { ...res.data }
    })
  },
  methods: {
    toDetail (item) {
      this.$router.push({
        path: '/corporate/detail',
        query: {
          id: item
        }
      })
    }
  }


}

</script>
<style lang='less' scoped>
#corporate {
  height: 100%;
  width: 100%;
}
.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  h2 {
    margin-top: 19px;
    color: #000;
    font-size: 24px;
    line-height: 2;
    font-weight: bold;
  }
  .desc {
    line-height: 2;
    font-size: 14px;
    line-height: 35px;
    color: #979797;
  }
  .data-block {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .data-item {
    padding-top: 20px;
    margin-bottom: 20px;
    width: 50%;
    text-align: center;
    h4 {
      margin-bottom: 8px;
      font-size: 10vw;
      line-height: 1;
      color: rgba(98, 194, 195, 1);
      font-family: "Conv_bahnschrift";
    }
    .desc {
      font-size: 14px;
      color: #3a3935;
      line-height: 24px;
    }
  }
}
.van-tabs {
  height: calc(100% - 44px);
}
/deep/.van-tabs__content {
  overflow: auto;
  height: calc(100% - 46px);
}
.cy-content {
  display: flex;
  flex-wrap: wrap;
  margin-top: 19px;

  justify-content: left;
  li {
    position: relative;
    padding: 0;
    overflow: hidden;
  }
  .cy-pic {
    overflow: hidden;
    padding-bottom: 100%;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .cy-con {
    position: absolute;
    left: 50%;
    top: 50%;
    text-align: center;
    transform: translate(-50%, -50%);
  }
  .tit-cn {
    font-size: 20px;
    color: #fff;
    line-height: 1;
    margin-top: 10px;
    margin-bottom: 12px;
  }
  .tit-en {
    font-size: 14px;
    color: #fff;
    line-height: 1;
  }
  .cyicon:after {
    content: "\e9ec";
  }
  .col-xs-6 {
    width: 50%;
  }
}
.cert-block {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  margin-top: 19px;

  .desc {
    margin-bottom: 20px;
    width: 100%;
    line-height: 2;
  }
  p {
    color: #5d5d5d;
    font-size: 14px;
    line-height: 2;
  }
  .pic {
    width: 100%;
    img {
      width: 100%;
    }
  }
}
</style>